import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bill",
  "use": "icon-bill-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-bill\">\r\n<g>\r\n\t<path d=\"M87.6,1.2V9c0,4.3-3.5,7.9-7.9,7.9H48.3c-4.3,0-7.9-3.5-7.9-7.9V1.2H87.6z\" />\r\n\t<path d=\"M32.6,1.2V13c0,6.1,4.6,11.1,10.6,11.7l1.1,0.1h39.3c6.1,0,11.1-4.6,11.7-10.6l0.1-1.1V1.2h7.9c8.7,0,15.7,7,15.7,15.7\r\n\t\tv94.2c0,8.7-7,15.7-15.7,15.7H24.7c-8.7,0-15.7-7-15.7-15.7V16.9c0-8.7,7-15.7,15.7-15.7H32.6z M80,37.8L64,56.9L48.6,37.8H30\r\n\t\tl19.2,22.6H30v12h25.7v11.1H30v11.4h25.7v21.8h16.2V94.9H98V83.5H71.9V72.4H98v-12H78.8L98,37.8L80,37.8z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bill.svg
// module id = hOaM
// module chunks = 164